// constants.js

// Travel constants
export const OUT_KILOMETRES_CODE = "OTK";
export const OUT_TRAVEL_TIME_CODE = "OTR";
export const FIRST_CONTACT = "FC";
export const EMAIL_REPORT = "EMR";

// Time Entry options
export const TE_ENTRY_OPTIONS = {
    BUILDTIME: 'BuildTime',
    SELECTTIME: 'SelectTime',
    EXPENSE: 'Expense'
};

// KII-1412: Combine RE and comment for TEs not sending an email and not coming from Outlook 
export const RE_COMMENT_CUTOFF_DATE = new Date("2025-Oct-28 05:00:00 PM");

// Activity code constants
const acConstants = {
    OUT_KILOMETRES_CODE,
    OUT_TRAVEL_TIME_CODE,
    FIRST_CONTACT,
    EMAIL_REPORT
};

// Vue plugin install method
acConstants.install = function (Vue) {
    Vue.prototype.$acConstants = (key) => {
        return acConstants[key];
    };
};

export default acConstants;